import { createReducer, on } from "@ngrx/store";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";
import {
  chartLoadErrorAction,
  chartLoadInitStartAction,
  chartLoadSuccessAction,
  chartUnsetKeyStorage,
} from "../actions/chart.action";

/**
 * Initial state of charts store
 */
const initialState: GenericStoreApiData = {
  loaded: false,
  errorGeneric: false,
  errorNotYetImplemented: false,
  isOldDataInUse: false,
  data: null,
};

/**
 * Reducer for charts
 */
export const ChartReducer = createReducer(
  initialState,
  on(chartUnsetKeyStorage, (chartObject: GenericStoreApiData, action) => {
    return initialState;
  }),
  on(chartLoadInitStartAction, (chartObject: GenericStoreApiData, action) => {
    return { ...chartObject, loaded: false };
  }),
  on(chartLoadSuccessAction, (chartObject: GenericStoreApiData, action) => {
    return {
      loaded: true,
      errorGeneric: false,
      errorNotYetImplemented: false,
      isOldDataInUse: false,
      data: action.chartObject,
    };
  }),
  on(chartLoadErrorAction, (chartObject: GenericStoreApiData, action) => {
    return {
      loaded: true,
      errorGeneric: true,
      errorNotYetImplemented: false,
      isOldDataInUse: false,
      data: null,
    };
  })
);
